// @flow

import type {ApplicationState} from '../../types'
import type {PlaceState} from '../types'

export function getPlaceList(appState: ApplicationState): ServiceProvider[] {
  return _getPlaceList(appState.place) 
}

function _getPlaceList(state: PlaceState): ServiceProvider[]{
  return state.placeList
}

getPlaceList.internal = _getPlaceList
